import { css } from 'lit-element';

export const ludsBaseFont = css`
  * {
    font-family: 'Inter', sans-serif;
  }
`;

export const ludsButtonFontStyling = css`
  :host {
    --luds-font-size-14: 14px;
    --luds-font-size-16: 16px;

    --luds-line-height-16: 16px;
    --luds-line-height-18: 18px;
    --luds-line-height-20: 20px;
    --luds-line-height-24: 24px;
  }
`;

export const ludsHeadingXS = css`
  .h-xs {
    color: var(--object-object-primary);
    font-feature-settings: 'cv11' on;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px; /* 128.571% */
    margin: 0;
  }
`;

export const ludsTypography = css`
  .p-default {
    font-feature-settings: 'cv11' on;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    line-height: 20px;
  }

  .baseline {
    font-feature-settings: 'cv11' on;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    line-height: 18px;
  }
`;

export const ludsHeadings = css`
  :host {
    --heading-fs-14: 14px;
    --heading-fs-16: 16px;

    --lh-18: 18px;
    --lh-20: 20px;

    --luds-font-weight-400: 400;
    --luds-font-weight-500: 500;
    --luds-font-weight-600: 600;
  }

  .h-xs {
    color: var(--object-object-primary);
    font-size: var(--luds-font-size-14);
    font-weight: var(--luds-font-weight-500);
    line-height: var(--lh-18);
  }

  .h-s {
    color: var(--object-object-primary);
    font-size: var(--heading-fs-16);
    font-weight: var(--luds-font-weight-500);
    line-height: var(--lh-20);
  }

  .h-xs,
  .h-s {
    margin: 0;
  }
`;

export const ludsTypographyFontWeight = css`
  .fw-400 {
    font-weight: 400;
  }

  .fw-600 {
    font-weight: 600;
  }
`;
